import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    fetchOrgTvChannelsAction,
    fetchTvChannelsAction,
    getOrgTvChannels,
    getTvChannels,
} from 'redux/slices/tvChannelSlice';

export const withChannels = (Component) => (props) => {
    const dispatch = useDispatch();
    const orgTvChannels = useSelector(getOrgTvChannels);
    const tvChannels = useSelector(getTvChannels);
    const [channels, setChannels] = useState(null);

    useEffect(() => {
        dispatch(fetchTvChannelsAction());
        dispatch(fetchOrgTvChannelsAction());
    }, [dispatch]);

    useEffect(() => {
        let array = [];
        tvChannels.forEach((channel) => {
            let activated = !!orgTvChannels.find(({ id }) => id === channel.id);
            array.push({
                ...channel,
                activated,
            });
        });
        setChannels(array);
    }, [orgTvChannels, tvChannels]);

    return (
        <Component
            {...props}
            channels={channels || []}
            loading={channels === null}
            orgTvChannels={orgTvChannels || []}
        />
    );
};

export default withChannels;
